(function () {
  function resize(root) {
    root.querySelectorAll('[data-project-unity-faq] .pu-faq-item.is-open .pu-faq-answer').forEach(function (answer) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    });
  }

  function initialise(root) {
    (root || document).querySelectorAll('[data-project-unity-faq]').forEach(function (list) {
      if (list.dataset.projectUnityFaqReady === 'true') return;
      list.dataset.projectUnityFaqReady = 'true';
      list.classList.add('is-enhanced');

      list.querySelectorAll('.pu-faq-item').forEach(function (item) {
        var question = item.querySelector('.pu-faq-question');
        var answer = item.querySelector('.pu-faq-answer');
        if (!question || !answer) return;
        question.addEventListener('click', function () {
          var open = !item.classList.contains('is-open');
          list.querySelectorAll('.pu-faq-item.is-open').forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherQuestion = other.querySelector('.pu-faq-question');
            var otherAnswer = other.querySelector('.pu-faq-answer');
            if (otherQuestion) otherQuestion.setAttribute('aria-expanded', 'false');
            if (otherAnswer) otherAnswer.style.maxHeight = '0px';
          });
          item.classList.toggle('is-open', open);
          question.setAttribute('aria-expanded', open ? 'true' : 'false');
          answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '0px';
        });
      });
      resize(root || document);
    });
  }

  window.ProjectUnityFaq = { initialise: initialise, resize: resize };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }
  window.addEventListener('resize', function () { resize(document); });
})();
